export default {
    config: {
        defaultWidth: 240
    },
    default: {
        label: 'Parts'
    },
    unique: [],
    lang: {
        name: 'Parts notes',
        category: ['User', 'Collection'],
        description: 'Has-parts and want-parts notes on the collection item.',
        views: ['list', 'sheet'],
    },
    filters: ['collection.parts']
}
